import "./logoutLandingPage.css"
function LogoutLandingPage() {
    return<>
    <div className="logoutLandingPageDiv">
      <h2>"You have Successfully logged Out" </h2>
      <h3>"I'm sending you a virtual hug and wishes of good health!"</h3>
      <img
              src="../hospital logo.png"
              alt="Logo"
              style={{ width: "90px", marginLeft: "10px" }}
            />
    </div>
    </>
}
export default LogoutLandingPage;